export const getUsageUpdatesMessage = ({
  type,
  currentDate,
  startDate,
  endDate,
  teams,
  users,
  teamClaims,
}: {
  type: 'Weekly' | 'Monthly' | 'Custom';
  currentDate: Date;
  startDate: string | null;
  endDate: string | null;
  teams: {
    id: number;
    name: string;
    createdAt: Date;
  }[]; // team name array
  users: {
    id: string;
    firstName: string | null;
    lastName: string | null;
    type: string | null;
    role: string | null;
    referralSource?: string | null;
    createdAt: Date;
  }[];
  teamClaims: {
    team: { name: string };
    status: string;
    id: number;
    createdAt: Date;
  }[];
}) => {
  return {
    blocks: [
      {
        type: 'header',
        text: {
          type: 'plain_text',
          text: `${process.env['NODE_ENV'] === 'development' ? '_STAGING_ ' : ''}:bar_chart: ${type === 'Custom' ? 'Manually triggered' : `Scheduled ${type}`} Stats Updates`,
        },
      },
      {
        type: 'context',
        elements: [
          {
            text: `*Today's date: ${currentDate.toLocaleDateString()}* \n${type === 'Custom' ? 'Manually triggered' : `Scheduled ${type}`} Updates (${new Date(startDate as any).toLocaleDateString()} - ${endDate ? new Date(endDate as any).toLocaleDateString() : currentDate.toLocaleDateString()})`,
            type: 'mrkdwn',
          },
        ],
      },
      {
        type: 'section',
        fields: [
          {
            type: 'mrkdwn',
            text: `*New Teams: ${teams.length}*\n${teams.map((team) => `<https://admin.baseballnearyou.com/teams/show/${team.id}|${team.name}> - ${team.createdAt.toLocaleDateString()}`).join('\n')}`,
          },
        ],
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `*New User Sign-ups: ${users.length}*\n${users
            .map(
              (user) =>
                `${user.createdAt.toLocaleDateString()} - <https://admin.baseballnearyou.com/users/show/${user.id}|${user.firstName ? user.firstName : '_none_'} ${user.lastName ? user.lastName : '_none_'} - ${user.type ? user.type : '_no type_'}${user.role ? ` (${user.role})` : ' _no role_'}> ${user.referralSource ? `referred by: ${user.referralSource}` : ''}`
            )
            .join('\n')}`,
        },
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `*Team Claims: ${teamClaims.length}*\n${teamClaims
            .map(
              (claim) =>
                `<https://admin.baseballnearyou.com/teams/claims/show/${claim.id}|${claim.team.name} *(${claim.status})*>  - ${claim.createdAt.toLocaleDateString()}`
            )
            .join('\n')}`,
        },
      },
    ],
  };
};
